(function () {
  'use strict';
  document.querySelectorAll('[data-before-after]').forEach(function (compare) {
    var range = compare.querySelector('.ba-compare__range');
    if (!range) return;
    function update() {
      compare.style.setProperty('--ba-position', range.value + '%');
    }
    range.addEventListener('input', update);
    range.addEventListener('change', update);
    update();
  });
})();
